import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Card from '../components/card'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './producing.css'

const Producing = (props) => {
  return (
    <div className="producing-container1">
      <Helmet>
        <title>
          3D-печать металлических деталей | WAAM производство | Arcobo
        </title>
        <meta
          name="description"
          content="Arcobo изготавливает металлические детали методом WAAM 3D-печати. Производство крупногабаритных изделий, прототипов и серийных деталей под заказ."
        />
        <meta
          property="og:title"
          content="3D-печать металлических деталей | WAAM производство | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo изготавливает металлические детали методом WAAM 3D-печати. Производство крупногабаритных изделий, прототипов и серийных деталей под заказ."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="3D-печать металлических деталей | WAAM производство | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo изготавливает металлические детали методом WAAM 3D-печати. Производство крупногабаритных изделий, прототипов и серийных деталей под заказ."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/producing"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/producing"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Producing","item":"https://arcobo.tech/producing"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name21"></HeaderMain>
      <hr className="producing-separator1"></hr>
      <Componenttextimage
        image1Src="/2_3D Printing/2_1_Producing/impeller%2011-1500w.webp"
        image1Alt="Деталь, изготовленная WAAM 3D-печатью"
        rootClassName="componenttextimageroot-class-name7"
        textComponent={
          <Fragment>
            <span className="producing-text10">
              <span>
                Изготавливаем металлические детали любой сложности методом
                роботизированной WAAM-печати — от единичных изделий до партий.
                Технология позволяет сократить сроки производства и отказаться
                от дорогостоящей оснастки.
              </span>
              <br></br>
              <br></br>
              <span className="producing-text14">Преимущества и выгоды:</span>
              <br className="producing-text15"></br>
              <span className="producing-text16">
                ✔ Производство без оснастки
              </span>
              <br></br>
              <span>
                Изготовление начинается сразу по CAD-модели без литьевых форм,
                штампов и специальной оснастки.
              </span>
              <br></br>
              <br className="producing-text20"></br>
              <span className="producing-text21">
                ✔ Крупногабаритные детали
              </span>
              <br></br>
              <span>
                Изготавливаем детали массой до 10 тонн и практически без
                ограничений по длине благодаря модульной архитектуре комплекса.
              </span>
              <br></br>
              <br className="producing-text25"></br>
              <span className="producing-text26">
                ✔ Высокая скорость производства
              </span>
              <br></br>
              <span>
                Скорость наплавки достигает 5 кг металла в час, что значительно
                сокращает сроки изготовления крупных изделий.
              </span>
              <br></br>
              <br className="producing-text30"></br>
              <span className="producing-text31">
                ✔ Экономия дорогостоящих материалов
              </span>
              <br></br>
              <span>
                Материал наносится только в необходимых местах, снижая расход
                металла и объем последующей механической обработки.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Изготовление металлических деталей"
      ></Componenttextimage>
      <Component3images
        image1Src="/2_3D Printing/3d_01-200h.webp"
        image1Alt="WAAM 3D-печать металлом"
        image2Src="/2_3D Printing/3d_02-200h.webp"
        image2Alt="WAAM 3D-печать металлом"
        image3Src="/2_3D Printing/3d_03-200h.webp"
        image3Alt="WAAM 3D-печать металлом"
        rootClassName="component3imagesroot-class-name18"
      ></Component3images>
      <div className="producing-container2">
        <Card
          text={
            <Fragment>
              <span className="producing-text34">
                <span>
                  Изготовление рабочих колес для центробежных, шламовых и
                  технологических насосов из нержавеющих, дуплексных и
                  жаропрочных сплавов. WAAM сокращает сроки и снижает стоимость
                  единичных и мелкосерийных деталей.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text37">
                <span>Рабочие колеса насосов</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/11_pump-500h.webp"
          imageAlt="Рабочие колеса насосов"
          rootClassName="cardroot-class-name10"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text40">
                <span>
                  Изготовление корпусов задвижек, клапанов, вентилей и других
                  элементов трубопроводной арматуры. Особенно эффективно для
                  деталей из коррозионностойких сплавов и оборудования с
                  длительными сроками поставки.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text43">
                <span>Запорная арматура</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/12_valve-500h.webp"
          imageAlt="Запорная арматура"
          rootClassName="cardroot-class-name17"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text46">
                <span>
                  Изготовление фурм, технологических наконечников и других
                  деталей металлургического оборудования для работы при высоких
                  температурах. Возможно применение жаропрочных и износостойких
                  материалов для увеличения ресурса.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text49">Фурмы для розлива стали</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/13_tuyere-500h.webp"
          imageAlt="Фурмы для розлива стали"
          rootClassName="cardroot-class-name16"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text50">
                <span>
                  Изготовление сопел, горелочных элементов и других деталей,
                  работающих при высоких температурах. Применяются никелевые и
                  другие жаропрочные сплавы для энергетики, металлургии и
                  нефтегазовой отрасли.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text53">
                <span>Сопла и жаропрочные детали</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/14_nozzle-500h.webp"
          imageAlt="Сопла и жаропрочные детали"
          rootClassName="cardroot-class-name15"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text56">
                <span>
                  Изготовление несущих элементов, корпусов, опор и силовых
                  кронштейнов сложной формы для промышленного оборудования. WAAM
                  позволяет получать прочные металлические детали практически
                  без ограничений по размерам.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text59">
                <span>Кронштейны и силовые корпуса</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/15_bracket-500h.webp"
          imageAlt="Кронштейны и силовые корпуса"
          rootClassName="cardroot-class-name14"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text62">
                <span>
                  Изготовление резервуаров, технологических емкостей и
                  герметичных сварных конструкций из стали, алюминия и
                  нержавеющих сплавов. Роботизированная наплавка обеспечивает
                  высокую скорость производства крупногабаритных изделий.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text65">
                <span>Баки и емкости</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/16_tank-500h.webp"
          imageAlt="Баки и емкости"
          rootClassName="cardroot-class-name13"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text68">
                <span>
                  Изготовление крупногабаритных элементов аэрокосмической
                  техники из алюминиевых, титановых и никелевых сплавов. WAAM
                  позволяет значительно сократить сроки производства опытных и
                  уникальных изделий.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text71">
                <span>Обтекатели и корпуса ракетоносителей</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/17_rocket-500h.webp"
          imageAlt="Обтекатели и корпуса ракетоносителей"
          rootClassName="cardroot-class-name12"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="producing-text74">
                <span>
                  Изготовление крупногабаритных и нестандартных деталей по
                  чертежам, 3D-моделям или обратному инжинирингу. WAAM
                  эффективен для единичного производства изделий, снятых с
                  производства или с длительными сроками поставки.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="producing-text77">
                <span>Крупногабаритные уникальные детали</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_1_Producing/18_unique-500h.webp"
          imageAlt="Крупногабаритные уникальные детали"
          rootClassName="cardroot-class-name11"
        ></Card>
      </div>
      <Component3images
        image1Src="/2_3D Printing/3d_11-200h.webp"
        image1Alt="Изделие WAAM 3D-печати"
        image2Src="/2_3D Printing/3d_12-200h.webp"
        image2Alt="Изделие WAAM 3D-печати"
        image3Src="/2_3D Printing/3d_13-200h.webp"
        image3Alt="Изделие WAAM 3D-печати"
        rootClassName="component3imagesroot-class-name10"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="producing-text80">
              <span>
                WAAM особенно эффективен для производства крупногабаритных
                металлических деталей, восстановленных узлов и изделий сложной
                геометрии. Технология применяется для изготовления корпусов,
                фланцев, кронштейнов, рабочих колес, пресс-форм, запорной
                арматуры, элементов энергетического оборудования, деталей
                горнодобывающей промышленности, авиации и машиностроения.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="producing-text83">
              <span>
                Наибольший экономический эффект достигается при изготовлении
                единичных изделий, мелких партий, крупных деталей, дорогих
                материалов и изделий с длительными сроками поставки. Во многих
                случаях WAAM позволяет снизить стоимость производства на 30–80%
                и сократить сроки изготовления в несколько раз.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="producing-text86">
              <span>
                Комплексы Arcobo поддерживают печать более чем 100 материалами,
                включая конструкционные и нержавеющие стали, инструментальные
                стали, алюминиевые и бронзовые сплавы, никелевые суперсплавы
                (Inconel), титановые сплавы, а также специальные материалы для
                ремонта и восстановления деталей.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="producing-text89">
              <span>
                Точность позиционирования роботизированной системы составляет
                ±0,06 мм. После печати детали проходят механическую обработку до
                требуемых размеров, благодаря чему достигаются допуски,
                соответствующие требованиям машиностроения.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="producing-text92">
              <span>
                Процесс включает несколько этапов: Анализ чертежа или 3D-модели.
                Подбор технологии и материала. Подготовка программы печати.
                Роботизированная WAAM-печать. Термическая обработка (при
                необходимости). Механическая обработка. Контроль геометрии и
                качества. Передача готовой детали заказчику.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="producing-text95">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="producing-text96">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="producing-text97">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие детали можно изготовить методом WAAM?"
        question2="Когда WAAM выгоднее традиционного производства?"
        question3="Какие материалы доступны для печати?"
        question4="Какая точность достигается после печати?"
        question5="Как проходит изготовление детали?"
        rootClassName="componentfaqroot-class-name5"
      ></Componentfaq>
      <hr className="producing-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name21"></FooterMain>
    </div>
  )
}

export default Producing
